const defaultError = require('../pages/error').default;

// The top-level (parent) route
const routes = {

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/login',
      load: () => import(/* webpackChunkName: 'login' */ '../pages/login'),
    },
    {
      path: '/email-login',
      load: () => import(/* webpackChunkName: 'login' */ '../pages/login'),
    },
    {
      path: '/email-login-verify',
      load: () => import(/* webpackChunkName: 'email-login-verify' */ '../pages/email-login-verify'),
    },
    {
      path: '/settings',
      children: [
        {
          path: '/contacts',
          protected: true,
          load: () => import(/* webpackChunkName: 'contacts' */ '../pages/settings/contacts'),
        },
        {
          path: '/payments',
          protected: true,
          load: () => import(/* webpackChunkName: 'payments' */ '../pages/settings/payments'),
        },
        {
          path: '/language',
          protected: true,
          load: () => import(/* webpackChunkName: 'language' */ '../pages/settings/language'),
        },
        {
          path: '',
          protected: true,
          load: () => import(/* webpackChunkName: 'settings' */ '../pages/settings'),
        },
      ],
    },
    {
      path: '/my-units',
      children: [
        {
          path: '/payments',
          protected: true,
          load: () => import(/* webpackChunkName: 'payments' */ '../pages/my-units/payments'),
        },
        {
          path: '/invoices',
          protected: true,
          load: () => import(/* webpackChunkName: 'invoices' */ '../pages/my-units/invoices'),
        },
        {
          path: '',
          protected: true,
          load: () => import(/* webpackChunkName: 'my-units' */ '../pages/my-units'),
        },
      ],
    },
    {
      path: '',
      protected: true,
      load: () => import(/* webpackChunkName: 'pay' */ '../pages/pay'),
    },
    //
    // // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ '../pages/not-found'),
    },
  ],
  path: '',

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = route.title || '';
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) { // eslint-disable-line no-undef
  routes.children.unshift({
    path: '/error',
    action: defaultError,
  });
}

export default routes;
